import { API } from "@project/shared"

export const listAllFacilities: any = () => {
  return API.get("/facilities")
}

export const fetchFacilitiesList = () => API.get(`/facilities`)

export const getAllOtherFacilities = () => API.get("joint-facility")
